import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"
}), 'PublishSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PublishSharp.js
// module id = 5630
// module chunks = 2